export function buildQueryParams(filters, pagination, search) {
  const params = new URLSearchParams();
  Object.entries(filters || {}).forEach(([key, value]) => {
    if (value !== '' && value !== null && value !== undefined) {
      params.set(key, value);
    }
  });
  if (search?.trim()) {
    params.set('q', search.trim());
  }
  if (pagination?.page) params.set('page', String(pagination.page));
  if (pagination?.perPage) params.set('per_page', String(pagination.perPage));
  return params;
}
